<div *ngIf="field" [ngStyle]="{'display': userCanView || alwaysShowControl ? '': 'none', 'min-width': width}">
    <ng-container [ngSwitch]="field.ControlTypeID">
        <!-- Textbox -->
        <ng-container *ngSwitchCase="controlTypes.Textbox">
            <ng-container [ngSwitch]="field.DataTypeID">
                <!-- Integer -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Integer" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input style="text-align: right" #control 
                        matInput 
                        [id]='field.FieldName + internalIndex' 
                        [name]='field.FieldName' 
                        type='text' 
                        [(ngModel)]='textValue' 
                        [numberMask]="numberMask"
                        [allowNegativeNumbers]="allowNegatives" 
                        [maximumEnforce]="field.EndRange"
                        [minimumEnforce]="field.StartRange"
                        [required]='field.IsRequired && !ignoreRequired' 
                        [disabled]="field.ReadOnly" 
                        (numberValue)="numberValueChanged($event)"
                    />
                </tyl-form-field>
                <!-- Decimal -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Decimal" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input style="text-align: right;" #control 
                        matInput 
                        [id]='field.FieldName + internalIndex' 
                        [name]='field.FieldName'
                         type='text' 
                        [(ngModel)]='textValue' 
                        [numberMask]="numberMask" 
                        [allowNegativeNumbers]="allowNegatives" 
                        [allowDecimal]='true'
                        [maximumEnforce]="field.EndRange"
                        [minimumEnforce]="field.StartRange"
                        [required]='field.IsRequired && !ignoreRequired' 
                        [disabled]="field.ReadOnly" 
                        [allowDecimal]="true"
                        (numberValue)="numberValueChanged($event)" 
                />
                </tyl-form-field>
                <!-- Telephone -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Telephone" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName + internalIndex' [name]='field.FieldName' type='text' [(ngModel)]='telephoneDisplayValue' (ngModelChange)="telephoneValueChanged()" 
                    [required]='field.IsRequired && !ignoreRequired' [disabled]="field.ReadOnly" [textMask]="{mask: phoneMask}"
                />
                </tyl-form-field>
                <!-- Email -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Email"  class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName + internalIndex' [name]='field.FieldName' type='text' [(ngModel)]='value' (ngModelChange)="valueChangeHandler()" 
                    [required]='field.IsRequired && !ignoreRequired' [disabled]="field.ReadOnly" minLength="{{field.StartRange ? field.StartRange : 0}}" 
                    maxLength="{{field.EndRange > 0 ? field.EndRange : 99999}}"
                />
                </tyl-form-field>
                <!-- Alphanumeric - Other -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchDefault  class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName + internalIndex' [name]='field.FieldName' type='text' [(ngModel)]='value' (ngModelChange)="valueChangeHandler()" 
                    [required]='field.IsRequired && !ignoreRequired' [disabled]="field.ReadOnly" minLength="{{field.StartRange ? field.StartRange : 0}}" 
                    maxLength="{{field.EndRange > 0 ? field.EndRange : 99999}}"
                />
                </tyl-form-field>
            </ng-container>
        </ng-container>
        <!-- Date -->
        <div [ngStyle]="{'width': width}" *ngSwitchCase="controlTypes.Date">
            <tyl-datepicker #control [id]='field.FieldName + internalIndex' (valueChange)="dateValueChanged($event)" [customHint]="hintLabel" 
             [label]='hideLabel ? "" : field.DisplayName' [value]="value" [isRequired]="field.IsRequired && !ignoreRequired" class="customDataField" 
            [disabled]="field.ReadOnly" (dateInputChange)="timeControl = $event" [showTodayButton]="showTodayButton">
            </tyl-datepicker>
        </div>
        <!-- Time -->
        <div *ngSwitchCase="controlTypes.Time">
            <tyl-time-field #timeInput *ngSwitchCase="controlTypes.Time" class="customDataField" [label]='hideLabel ? "" : field.DisplayName' [id]='field.FieldName + internalIndex' 
            [name]='field.FieldName' [required]='field.IsRequired && !ignoreRequired' [disabled]="field.ReadOnly" [(timeValue)]="value" (timeValueChange)="valueChangeHandler()" 
            (timeFieldChange)="timeControl = $event" [customHint]="hintLabel" [width]="getTimeFieldWidth()" [showNowButton]="showNowButton"></tyl-time-field>
        </div>
        <!-- DateTime -->
        <div [ngStyle]="{'width': width}" *ngSwitchCase="controlTypes.DateTime">
            <tyl-datepicker #control [id]='field.FieldName + internalIndex' [label]='hideLabel ? "" : field.DisplayName' (valueChange)="dateValueChanged($event)" 
            [(value)]="value" [isRequired]="field.IsRequired && !ignoreRequired" [disabled]="field.ReadOnly" class="customDataField"  
            [customHint]="hintLabel" [showTodayButton]="showTodayButton">
            </tyl-datepicker>
            <tyl-time-field #timeInput class="customDataField" [label]='hideLabel ? "" : field.DisplayName' [id]='field.FieldName + internalIndex' [name]='field.FieldName'
            [required]='field.IsRequired && !ignoreRequired' [disabled]="field.ReadOnly" [timeValue]="localTimeValue" (timeValueChange)="timeValueChange($event)" 
            (timeFieldChange)="timeControl = $event" [customHint]="hintLabel"></tyl-time-field>
        </div>
        <!-- Checkbox -->
        <ng-container *ngSwitchCase="controlTypes.Checkbox">
            <tyl-checkbox #control *ngSwitchCase="controlTypes.Checkbox" (change)="valueChangeHandler()"
                name="{{'cbName'+ '_' + field.FieldName + '_' + internalIndex}}" id="{{'cbID'+ '_' + field.FieldName + '_' + internalIndex}}" [(checked)]='value' [disabled]="field.ReadOnly">
                {{field.DisplayName}}
            </tyl-checkbox>
        </ng-container>
        <!-- Dropdown -->
        <data-def-dropdown *ngSwitchCase="controlTypes.Dropdown" 
            [useCodeAsValue]='field.UseDataDefCode'
            [dataDefEnum]="field.LookupENUM" 
            [label]='hideLabel ? "" : field.DisplayName' 
            class="customDataField" 
            [hintLabel]="hintLabel" 
            [ngStyle]="{'width': width}"
            [(value)]="value" 
            (valueChange)="valueChangeHandler()" 
            [required]='field.IsRequired && !ignoreRequired' 
            [disabled]="field.ReadOnly"
            (controlEmitter)="control = $event"
            [useDefaultValue]="!masterId || masterId <= 0"></data-def-dropdown>
        <!-- Radio Buttons -->
        <data-def-radio-buttons *ngSwitchCase="controlTypes.RadioButtons" 
            [useCodeAsValue]='field.UseDataDefCode'
            [dataDefEnum]="field.LookupENUM" 
            [label]='hideLabel ? "" : field.DisplayName' 
            class="customDataField" 
            [ngStyle]="{'width': width}"
            [(value)]="value" 
            (valueChange)="valueChangeHandler()" 
            [required]='field.IsRequired && !ignoreRequired' 
            [disabled]="field.ReadOnly"
            (controlEmitter)="control = $event"
            [useDefaultValue]="!masterId || masterId <= 0"></data-def-radio-buttons>
        <!-- Buttons -->
        <data-def-button-list *ngSwitchCase="controlTypes.Buttons" [dataDefEnum]="field.LookupENUM" [label]='hideLabel ? "" : field.DisplayName' class="customDataField" [ngStyle]="{'width': width}"
            [useCodeAsValue]='field.UseDataDefCode' [(value)]="value" (valueChange)="valueChangeHandler()" [required]='field.IsRequired && !ignoreRequired' [disabled]="field.ReadOnly"
            (controlEmitter)="control = $event"
            [useDefaultValue]="!masterId || masterId <= 0"></data-def-button-list>
        <!-- Multi-line Textbox -->
        <tyl-form-field *ngSwitchCase="controlTypes.MultiLineTextbox" [label]='hideLabel ? "" : field.DisplayName' class="customDataField" 
            [hint]="field.EndRange ? field.EndRange - (value ? value.length : 0) + ' characters left': ''" 
            [ngStyle]="{'width': width}" [hintLabel]="hintLabel" >
            <textarea #control matInput [id]="'txt' + field.FieldName + internalIndex" [required]="field.IsRequired && !ignoreRequired"  [disabled]="field.ReadOnly" [rows]="noteRows"
                [(ngModel)]='value' [name]="'ta' + field.FieldName" (change)="valueChangeHandler()" [minLength]="field.StartRange" [maxLength]="field.EndRange">
            </textarea>
        </tyl-form-field>
        <!-- Text -->
        <ng-container *ngSwitchCase="controlTypes.Text">
            <quill-editor #control [ngModel]="value" [readOnly]="true" placeholder="" class="ql-textOnly" 
                [name]="'quill' + field.FieldName" class="customDataField">
            </quill-editor>
        </ng-container>
    </ng-container>
</div>